import Vue from "vue";

Vue.prototype.$utils = {
  gdjz: function (div, offset, animate, callback) {
    let dom = div;
    if (dom) {
      var a, b, c, d;
      d = dom.offsetTop;
      a = eval(d + offset);
      b = document.documentElement.scrollTop || document.body.scrollTop; //  获取窗口滚动条高度
      c = document.documentElement.clientHeight || document.body.clientHeight; // 获取浏览器可视区的高度
    //   if (dom.classList.contains(animate) && b + c > a + dom.offsetHeight) {
    //     dom.classList.remove(animate);
    //     return
    //   }
      if (b + c > a) {
        callback && callback();
      }
    }
  },
};
